<template>
	<div class="ui mini modal" ref="modal">
		<div class="content">
			<p>Aktivacija dostopa je uspešno zaključena.</p>
		</div>
		<div class="actions">
			<div class="ui yellow right button approve" v-on:click="close">V iZbirko</div>
		</div>
	</div>
</template>

<script>
	import popup from './Popup.vue'

    export default {
    	mixins: [popup],
        methods: {
        	close() {
        		window.location.href = this.route('izbirka');
        	}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/modals/ActivationCodeSuccess.vue